import { gql } from '@apollo/client'

export const GET_PROJECTS = gql`
  query getProjects {
    projects {
      id
      name
      geojson
      center
    }
  }
`

export const GET_PROJECT = gql`
  query getProject($id: String!) {
    project(id: $id) {
      id
      scenarios {
        id
        name
      }
    }
  }
`
export const MUTATE_PROJECT = gql`
  mutation createProject($input: ProjectInput!) {
    createOrUpdateProject(input: $input) {
      id
    }
  }
`
